/**
 * @file The line insight component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InsightBreeze } from '../insight-base/insight-breeze';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../../insights/insight.service';
import { LocalisationService } from '../../core/localisation.service';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Insight component that shows a Line Chart.
 */
var InsightLineComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightLineComponent, _super);
    /**
     * Constructs an InsightLineComponent.
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightLineComponent(resourceService, provider, insightService, localisationService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.alertsService = alertsService;
        // Data object for insight line component
        _this.data = {
            axis: {
                y: []
            },
            items: []
        };
        _this.maxValue = 0;
        _this.minValue = 0;
        return _this;
    }
    InsightLineComponent.prototype.findMaxValue = function (items) {
        var maxValue = 240; // = 4 uur (4 * 60)
        // Run through items
        items.forEach(function (item) {
            // Run through values
            item.values.forEach(function (value) {
                if (typeof value !== 'number') {
                    console.warn('Expecting a number as value for finding the max value (' + typeof value + ')');
                }
                // Save if larger
                if (value > maxValue) {
                    maxValue = value;
                }
            });
        });
        return this.roundToNearest(Math.ceil(maxValue));
    };
    InsightLineComponent.prototype.findMinValue = function (items) {
        var minValue = -1;
        // Run through items
        items.forEach(function (item) {
            // Run through values
            item.values.forEach(function (value) {
                if (typeof value !== 'number') {
                    console.warn('Expecting a number as value for finding the min value (' + typeof value + ')');
                }
                // Set initial value
                if (minValue === -1 && value !== NaN) {
                    minValue = value;
                }
                // Save if smaller
                if (value < minValue) {
                    minValue = value;
                }
            });
        });
        if (minValue === -1) {
            minValue = 0;
        }
        return this.roundToNearest(Math.floor(minValue));
    };
    InsightLineComponent.prototype.roundToNearest = function (number) {
        return Math.round(number);
        // return Math.round(number / 10) * 10;
    };
    /**
     * Set the list insight data
     */
    InsightLineComponent.prototype.setData = function (items) {
        // If there are items set them or otherwise set state in nodata
        if (items.length > 0) {
            // Find min and max
            this.maxValue = this.findMaxValue(items);
            this.minValue = this.findMinValue(items);
            // Calculate x axis and fill the array
            var stepSize = (this.maxValue - this.minValue) / 4;
            var axisY = [];
            axisY.unshift(this.toDuration(this.minValue));
            for (var i = 1; i < 4; i++) {
                axisY.unshift(this.toDuration(this.roundToNearest(i * stepSize)));
            }
            axisY.unshift(this.toDuration(this.maxValue));
            // Store data
            this.data['axis'] = {
                y: axisY
            };
            this.data['items'] = items;
            // Set ready
            this.setState('ready');
        }
        else {
            this.setState('nodata');
        }
    };
    InsightLineComponent.prototype.maxLineHeight = function () {
        return (this.insightContentHeight / 6) * 5;
    };
    InsightLineComponent.prototype.baseLineHeight = function () {
        return (this.pointLineHeight() * this.minValue);
    };
    InsightLineComponent.prototype.minLineHeight = function () {
        return (this.insightContentHeight / 6);
    };
    InsightLineComponent.prototype.rangeLineHeight = function () {
        return this.maxLineHeight() - this.minLineHeight();
    }; // = 100%
    InsightLineComponent.prototype.pointLineHeight = function () {
        return this.rangeLineHeight() / (this.maxValue - this.minValue);
    };
    return InsightLineComponent;
}(InsightBreeze));
export { InsightLineComponent };
